module.exports = __webpack_public_path__ + "static/media/resi04.4cae853b.jpeg";